import React from 'react';

import { useEnergyLabelHover } from './hooks/handlers';
import RecommendationSlideContent from './RecommendationSlideContent';
import type { RecommendationsSlideProps } from './types';

const RecommendationSlideWithEnergyClass = (props: RecommendationsSlideProps) => {
  const { urlWithHash, handleMouseOver } = useEnergyLabelHover(props.url);

  return <RecommendationSlideContent {...props} onMouseOver={handleMouseOver} url={urlWithHash} />;
};

export default RecommendationSlideWithEnergyClass;
